import styled from "styled-components";

export const TextContainer = styled.div`
    flex: 1;
    padding-right: 2rem; 
    margin-bottom: 2em;   
    display: flex;
    flex-direction: column;
    align-items: center;

  p {
    line-height: 1.7;
    color: var(--gray-darkest);
  }

  @media (max-width: 48rem) {
    padding-right: 0;
    margin-bottom: 1.5rem;
  }
`;

export const Container = styled.div`
  margin-top: 3rem;
  padding: 1.5rem 1rem;
  background: var(--color-white);
  border-radius: 8px;
`;

interface ButtonContainerProps {
    align?: 'flex-start' | 'center';
}

export const ButtonContainer = styled.div<ButtonContainerProps>`
    width: 100%;
    display: flex;
    justify-content: ${({ align }) => align || 'flex-start'};
    gap: 1rem;

    @media (max-width: 75rem) {
        justify-content: ${({ align }) => align || 'flex-start'};
        margin-bottom: 4rem;
    }

    @media (max-width: 48rem) {
        flex-direction: column;
        gap: 1.5rem;
    }
`;
